import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Alert from "../../../shared/common/alert";
import Socket from "../../../../socket/socket";
import { Button, FormGroup, Input } from "reactstrap";
import Minus from "../../../../assets/images/dw20/icons/minus.png";
import Plus from "../../../../assets/images/dw20/icons/plus.png";
import Play from "../../../../assets/images/verboden/play.png";
import _ from "lodash";
import * as paramsAction from "../../../../redux/gameParams/actions";

const DWOption = (props) => {
  let roomData = props.gameReducer.roomObj;
  let users = props.gameReducer.roomObj.users;
  let gameObj = props?.paramsReducer?.gameObj?.screens?.lobby;
  const gameName = props.gameReducer.gameName;
  const status = _.get(roomData, "game_state.status");
  const [round, setRound] = useState(
    gameName && gameName !== "" && gameName === "DW20" ? 4 : 10
  );
  let scoreToWin = roomData.lobby_parameters.score_to_win;

  useEffect(() => {
    return Socket.addListener("update-status", () => {
      props.history.push("/done-with-2020");
    });
  }, []);

  useEffect(() => {
    if (status != "Joining") {
      let gameObj = props.gameReducer;
      let dataObj = {
        gameName:
          gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
      };
      props.getGameData(dataObj);
      if (Object.keys(props.paramsReducer.gameObj).length > 0) {
        props.history.push("/done-with-2020");
      }
    }
  }, [status, props.paramsReducer.gameObj]);

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      score_to_win: round
    };
    Socket.sendMessage(data);
  }, [round]);

  const onAddOrSubtractRound = (key) => {
    let currentRound = round;

    if (key === "add") {
      if (round >= 0) {
        if (currentRound >= 7) {
          Alert(200, "Max Score can be 7 only");
          return;
        } else {
          currentRound = parseInt(currentRound) + 1;
          setRound(currentRound);
        }
      }
    } else {
      if (round > 0) {
        currentRound = currentRound - 1;
        if (currentRound <= 1) {
          setRound(1);
        } else {
          setRound(currentRound);
        }
      }
    }
  };

  const handleChange = (e) => {
    setRound(e.target.value);
    return;
  };

  const onStartGame = () => {
    if (users && users.length < 3) {
      Alert(400, "Need at least 3 players to start the game");
      return;
    }
    if (round <= 0) {
      Alert(400, "Please enter correct no of Score to start the game");
    } else {
      let data = {
        action: "update-status",
        roomId: roomData.id,
        scoreToWin: parseInt(round),
        tableTopName: gameName
      };
      Socket.sendMessage(data);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-end  pt-3">
        <div className="score-to-win">
          <div className="labelWrapper">
            <p>{gameObj ? gameObj.score_limit_label : "Score to win"}</p>
          </div>

          <div className="inpWrapper">
            <div className="round">
              <div className="counter d-flex align-items-center">
                <Button
                  color="themePurple"
                  onClick={() => onAddOrSubtractRound("subtract")}
                >
                  <img src={Minus} alt="minus" />
                </Button>
                <FormGroup className="mx-3 mb-0">
                  <Input
                    min="1"
                    max="12"
                    type="number"
                    name="round"
                    onChange={(evt) => handleChange(evt)}
                    value={scoreToWin}
                    disabled
                  />
                </FormGroup>
                <Button
                  color="yellow"
                  onClick={() => onAddOrSubtractRound("add")}
                >
                  <img src={Plus} alt="plus" />
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="playBtn">
          <Button color="yellow" onClick={onStartGame}>
            <img src={Play} alt="" className="mr-3" />
            {gameObj ? gameObj.button_text : "Start"}
          </Button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(DWOption);
